var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7114 12.0597C22.5159 11.7907 17.8599 5.47217 11.9999 5.47217C6.13987 5.47217 1.48387 11.7902 1.28887 12.0592C1.09837 12.3217 1.09837 12.6777 1.28887 12.9407C1.48387 13.2097 6.13987 19.5282 11.9999 19.5282C17.8599 19.5282 22.5159 13.2097 22.7114 12.9412C22.9024 12.6782 22.9024 12.3222 22.7114 12.0597ZM11.9999 18.0282C7.73487 18.0282 3.98087 13.8812 2.84937 12.5002C3.98087 11.1192 7.73487 6.97217 11.9999 6.97217C16.2649 6.97217 20.0189 11.1192 21.1509 12.5002C20.0189 13.8812 16.2649 18.0282 11.9999 18.0282ZM14.1104 9.94117C13.7664 10.1712 13.6739 10.6372 13.9039 10.9817C14.1549 11.3572 14.2879 11.7962 14.2879 12.2507C14.2879 13.5117 13.2614 14.5382 12.0004 14.5382C10.7394 14.5382 9.71287 13.5117 9.71287 12.2507C9.71287 10.9897 10.7389 9.96317 12.0004 9.96317C12.4149 9.96317 12.7504 9.62767 12.7504 9.21317C12.7504 8.79867 12.4149 8.46317 12.0004 8.46317C9.91187 8.46317 8.21287 10.1622 8.21287 12.2507C8.21287 14.3392 9.91187 16.0382 12.0004 16.0382C14.0889 16.0382 15.7879 14.3392 15.7879 12.2507C15.7879 11.4987 15.5679 10.7717 15.1514 10.1482C14.9204 9.80267 14.4544 9.71117 14.1104 9.94117Z",
    fill: "#9A9A9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.501e903cbaa14be97697279a53bbe3a6.svg";
export { ForwardRef as ReactComponent };